import RuleCard        from '../components/RuleCard';
import useScrollReveal from '../hooks/useScrollReveal';

import surprisedSvg from '../assets/images/surprised.svg';

const RULES = [
  {
    number: 1,
    color: '#BB55FF',
    title: 'Tap a charged cell',
    body: 'Any cell with a value > 0 can be tapped. It fires a ripple outward in all 4 directions, travelling exactly N steps (where N is the cell\'s value).',
  },
  {
    number: 2,
    color: '#00FF77',
    title: 'Ripple hits non-zero cells',
    body: 'Every non-zero cell the ripple reaches gets decremented by 1. Zero cells are skipped — but the ripple keeps travelling right through them.',
  },
  {
    number: 3,
    color: '#FF3399',
    title: 'Win: clear the board',
    body: 'The puzzle is solved when all 25 cells reach zero. Try to match or beat Par — the minimum number of taps needed to solve the puzzle.',
  },
];

export default function HowToPlay() {
  const [ref, visible] = useScrollReveal();

  return (
    <section className="section" style={{ background: 'var(--surface)' }}>
      <div className="container section-content">

        <div ref={ref} className={`reveal ${visible ? 'visible' : ''}`}>
          <div className="htp-opener">
            <img src={surprisedSvg} alt="Surprised mascot" />
            <div>
              <h2 className="section-headline">How to Play</h2>
              <p className="section-sub" style={{ marginTop: 8 }}>
                Master three rules and you can solve any puzzle.
              </p>
            </div>
          </div>
        </div>

        <div className="rules-grid">
          {RULES.map((rule, i) => (
            <RuleCard key={rule.number} {...rule} delay={i * 150} />
          ))}
        </div>

      </div>
    </section>
  );
}
